import queryString from 'query-string';

/**
 * 将对象转为URL查询参数
 *
 * @param {{ [key: string]: string }} obj 传入对象
 * @return {string} 查询参数
 */
export const objToQuery = (obj: { [key: string]: string }) => {
  const params = new URLSearchParams();

  // eslint-disable-next-line no-restricted-syntax
  for (const [key, value] of Object.entries(obj)) {
    if (!value) {
      // eslint-disable-next-line no-continue
      continue;
    }
    params.append(key, value);
  }

  const queryString = params.toString();

  return queryString ? `?${queryString}` : '';
};

/**
 *
 * @param url
 */
export const mergeQueryParams = (url: string) => {
  // eslint-disable-next-line no-script-url
  if (url?.startsWith('javascript:')) {
    return url;
  }
  const { l } = queryString.parseUrl(window.location.href).query || {};
  const targetUrlObj = queryString.parseUrl(url);
  // 和小棠沟通，如果带着 L 参链接进来，点击其它 L 参的链接，以带进来的 L 参为准
  const mergedQuery = { ...targetUrlObj.query, ...(l ? { l } : {}) };
  return queryString.stringifyUrl({
    url: targetUrlObj.url,
    query: mergedQuery,
  });
};

/**
 * 将当前页面的所有 query 参数透传到目标 URL 上
 * 目标 URL 已有的同名参数不会被覆盖
 */
export const forwardCurrentQuery = (targetPath: string): string => {
  if (typeof window === 'undefined') {
    return targetPath;
  }
  const currentParams = queryString.parseUrl(window.location.href).query;
  const targetUrlObj = queryString.parseUrl(targetPath);
  const mergedQuery = { ...currentParams, ...targetUrlObj.query };
  return queryString.stringifyUrl({
    url: targetUrlObj.url,
    query: mergedQuery,
  });
};

/**
 * 如果是 edu.net 的域名，返回 edu.net 的 API地址
 * @returns
 */
export const getAPIBaseUrl = (api: string | undefined) => {
  if (!api) {
    return '';
  }
  const isEduUrl = globalThis?.location?.href?.includes?.('.wukongedu.net');
  return isEduUrl ? api.replace('.wukongacademy.com', '.wukongedu.net') : api;
};

/**
 * 根据url获取当前域名
 * @returns
 */
export const getCurrentDomain = (domain: string | undefined) => {
  if (!domain) {
    return '';
  }

  // 只有线上环境才进行域名替换逻辑
  if (process.env.NEXT_PUBLIC_STAGE === 'prod') {
    // 客户端检查，避免 SSR 错误
    if (typeof window === 'undefined') {
      return domain;
    }

    let result = window.location.origin.includes('edu.net')
      ? domain.replace('sch.com', 'edu.net')
      : domain.replace('edu.net', 'sch.com');

    if (result.includes('ofw.wukongsch.com')) {
      result = result.replace('ofw.wukongsch.com', 'www.wukongsch.com');
    }

    return result;
  }

  // 非线上环境直接返回传入的域名
  return domain;
};
